// @flow
import React from 'react';
import styled, { type StyledComponent } from 'styled-components';

import { DSTokenMap } from '@rover/kibble/styles';
import LoadingSpinner from '@rover/react-lib/components/typography/LoadingSpinner';

const Overlay: StyledComponent<{}> = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: ${DSTokenMap.BACKGROUND_COLOR_PRIMARY};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledSpinner: StyledComponent<{}> = styled(LoadingSpinner)`
  font-size: 24px;
`;

const LoadingOverlay = () => (
  <Overlay>
    <StyledSpinner data-qa-id="credit-card-forms-spinner" />
  </Overlay>
);

export default LoadingOverlay;



// WEBPACK FOOTER //
// ../react-lib/src/components/forms/CreditCardForm/BraintreeCreditCardForm/LoadingOverlay.jsx